enum HealthyChurchComponent {
    Core = 'Core',
    UI = 'UI',
}

export default HealthyChurchComponent;
